module.exports = __webpack_public_path__ + "img/ctrl-sqrt-swap-stub-1.0e156156.svg";